import request from '@/utils/request'

export function selectRetouchingFile(currentPage,pageSize,data) {

    return request({
        url: `api/serviceCenter/retouchingFile/selectRetouchingFile?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}




export function getLargeCategory(data) {
    return request({
        url: `api/serviceCenter/retouchingFile/getLargeCategory`,
        method: 'post',
        data,
    })
}




export function updateConfirmStatus(data) {

    return request({
        url: `api/serviceCenter/retouchingFile/updateConfirmStatus?`,
        method: 'post',
        data,
    })
}

export function updateDownloadStatus(data) {

    return request({
        url: `api/serviceCenter/retouchingFile/updateDownloadStatus?`,
        method: 'post',
        data,
    })
}

export function updateCollage(data) {

    return request({
        url: `api/serviceCenter/retouchingFile/updateCollage?`,
        method: 'post',
        data,
    })
}

export function updateCollageUrgent(data) {

    return request({
        url: `api/serviceCenter/retouchingFile/updateCollageUrgent?`,
        method: 'post',
        data,
    })
}
export function updateToArtificial(data) {

    return request({
        url: `api/serviceCenter/retouchingFile/updateToArtificial?`,
        method: 'post',
        data,
    })
}
export function retouchingFileBatchDelete(data) {

    return request({
        url: `api/serviceCenter/retouchingFile/bathDeleteRetouchingFile?`,
        method: 'post',
        data,
    })
}

export function confirmConfirmStatus(data) {

    return request({
        url: `api/serviceCenter/retouchingFile/confirmConfirmStatus?`,
        method: 'post',
        data,
    })
}

export function upDateRetouchingFile(data) {
    return request({
        url: `api/serviceCenter/retouchingFile/upDateRetouchingFile`,
        method: 'post',
        data,
    })
}


export function selectAllLargeCategory(data) {
    return request({
        url: `api/serviceCenter/retouchingFile/selectAllLargeCategory?access=${data}`,
        method: 'post',
    })
}
export function selectAllSubclass(data) {
    return request({
        url: `api/serviceCenter/retouchingFile/selectAllSubclass`,
        method: 'post',
        data,
    })
}